export default {
  methods: {
    formatTicket (ticket) {
      const {
        TicketId,
        Description,
        Discount,
        Name,
        TicketInstanceId,
        ValidDueAt,
        ...rest
      } = ticket
      return {
        Id: TicketId,
        TicketInstanceId,
        Name,
        OrderDiscount: Discount,
        ValidDue: ValidDueAt,
        Desc: Description,
        ...rest
      }
    },
    // api
    async getTicketAvailableForService (
      {
        ServiceId,
        OrderAmount
      }
    ) {
      try {
        if (this.isQuotationMode) return await this.getQuotationCanUseTickets(OrderAmount)
        const { data } = await this.$axios.post('/api/Ticket/TicketAvailableForService', {
          ServiceId,
          OrderAmount
        })
        return Promise.resolve(data.Data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getOrderMaxBonus ({
      ServiceId,
      OrderAmount
    }) { // 取得訂單可使用紅利上限、折抵金額上限
      try {
        if (this.isQuotationMode) return await this.getQuotationCanUseBonus(OrderAmount)
        const requestData = {
          service_id: ServiceId,
          order_amount: OrderAmount > 0 ? OrderAmount : 0
        }
        const { data } = await this.$axios.get('/api/v2/Order/GetOrderMaxBonus', {
          params: requestData
        })
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject('取得紅利點數失敗，請稍後再試')
      }
    },
    async getQuotationCanUseTickets (OrderAmount) { // 取得個人未使用票券
      try {
        const requestData = {
          OrderId: this.orderId,
          QuotationId: this.quotationId,
          OrderAmount
        }
        const { data } = await this.$axios.get(`/api/v2/Order/${this.orderId}/Quotation/${this.quotationId}/CanUseTickets`, { params: requestData })
        return Promise.resolve(data.Data.Tickets.map(this.formatTicket))
      } catch (error) {
        console.log(error)
        return Promise.reject('取得優惠券失敗，請稍後再試')
      }
    },
    async getQuotationCanUseBonus (OrderAmount) { // 取得訂單可使用紅利上限、折抵金額上限
      try {
        const requestData = {
          OrderId: this.orderId,
          QuotationId: this.quotationId,
          OrderAmount: OrderAmount > 0 ? OrderAmount : 0
        }
        const { data } = await this.$axios.get(`/api/v2/Order/${this.orderId}/Quotation/${this.quotationId}/CanUseBonus`, {
          params: requestData
        })
        return Promise.resolve(data.Data)
      } catch (error) {
        console.log(error)
        return Promise.reject('取得紅利點數失敗，請稍後再試')
      }
    },
    async checkTicketUsageHandler (isAutoCheck, { ServiceId, OrderAmount = 0 }) {
      // isAutoCheck => false: 需詢問再移除  true: 可直接移除

      if (!this.$auth.loggedIn) return

      const clearTicket = () => {
        this.$emit('updateDiscountUsage', {
          type: 'ticket',
          data: {
            discount: 0,
            TicketInstanceId: null,
            index: 0,
            detail: null,
            list: ticketData
          },
          isAutoCheck
        })
      }

      const ticketData = await this.getTicketAvailableForService({ ServiceId, OrderAmount }).catch((err) => {
        console.log('err', err)
        clearTicket()
      })

      if (!ticketData) return false

      const selectTicketIndex = ticketData.findIndex(v => v.TicketInstanceId === this.discountData.ticket.TicketInstanceId)
      const selectTicket = ticketData[selectTicketIndex]
      const avaliableTicketList = ticketData?.filter(ticket => ticket.OrderDiscount <= OrderAmount)
      if (!isAutoCheck && !selectTicket) {
        await this.confirmUseDiscount()
        if (!this.discountCode.acceptResult) return false
      }
      if (selectTicketIndex > -1) {
        this.$emit('updateDiscountUsage', {
          type: 'ticket',
          data: {
            discount: selectTicket.OrderDiscount,
            TicketInstanceId: selectTicket.TicketInstanceId,
            index: selectTicketIndex,
            detail: selectTicket,
            list: ticketData
          },
          isAutoCheck
        })
      } else if (avaliableTicketList.length) {
        const defaultTicket = avaliableTicketList[0]
        this.$emit('updateDiscountUsage', {
          type: 'ticket',
          data: {
            discount: defaultTicket.OrderDiscount,
            TicketInstanceId: defaultTicket.TicketInstanceId,
            index: 0,
            detail: defaultTicket,
            list: avaliableTicketList
          },
          isAutoCheck
        })
      } else {
        clearTicket()
      }
      return true
    },
    async updateAvaliableBonusHandler (isAutoCheck, { ServiceId, OrderAmount = null }) {
      // isAutoCheck => false: 需詢問再移除  true: 可直接移除
      if (!this.$auth.loggedIn) return
      const tempBonus = _.cloneDeep(this.discountData.bonus)
      try {
        tempBonus.isLoading = true

        this.$emit('updateDiscountUsage', {
          type: 'bonus',
          data: tempBonus
        })

        // 紅利資料處理
        const bonusData = await this.getOrderMaxBonus({ ServiceId, OrderAmount })

        const formatData = await this.setOrderBonus(isAutoCheck, { bonusData, tempBonus })
        tempBonus.point = formatData.bonusData
        tempBonus.isLoading = false
        this.$emit('updateDiscountUsage', {
          type: 'bonus',
          data: tempBonus
        })
      } catch (err) {
        console.log(err)
        this.$store.dispatch('toast', {
          isOpen: true,
          text: '取得紅利點數失敗，請稍後再試',
          type: 'error'
        })

        tempBonus.isLoading = false
        this.$emit('updateDiscountUsage', {
          type: 'bonus',
          data: tempBonus
        })
      }
    },
    async setOrderBonus (isAutoCheck, { bonusData, tempBonus }) {
      const hasPersonalBonus = bonusData?.PersonalBonus?.BonusSum > 0 ||
        bonusData?.PersonalEnterpriseCoin?.Amount > 0 ||
        bonusData?.CustomerBonusAmount > 0 ||
        bonusData?.CustomerEnterpriseCoinAmount > 0
      const serviceCanUsePersonalBonus = bonusData?.BonusResult?.BonusAmount || bonusData.CanUseBonusAmount || 0
      const serviceCanUseEnterpriseBonus = bonusData?.EnterpriseCoinResult?.CoinAmount || bonusData.CanUseEnterpriseAmount || 0
      const hasServiceCanUseBonus = serviceCanUsePersonalBonus || serviceCanUseEnterpriseBonus
      if (hasPersonalBonus) {
        if (hasServiceCanUseBonus) {
          if (tempBonus.state !== 'notuse' && tempBonus.state !== 'used') {
            tempBonus.state = 'notuse'
          }
        } else {
          if (!isAutoCheck && this.discountCode && this.discountCode.acceptResult === null) {
            await this.confirmUseDiscount()
            if (!this.discountCode.acceptResult) return false
          }
          tempBonus.state = 'disable'
        }
      } else {
        tempBonus.state = 'empty'
      }
      bonusData = {
        CanUseBonusAmount: serviceCanUsePersonalBonus,
        CanUseEnterpriseAmount: serviceCanUseEnterpriseBonus
      }
      return { bonusData, tempBonus }
    },
    confirmUseDiscount () {
      return new Promise(async (resolve, reject) => {
        this.$alert({
          title: '系統提示',
          message: '使用優惠後，當前的優惠券或紅利點數將無法繼續適用，確定要使用嗎？',
          btn: [
            {
              btnText: '取消',
              btnColor: '',
              depressed: true,
              outlined: false,
              btnClick: () => {
                this.$alert.close()
                this.discountCode.acceptResult = false
                resolve(false)
              }
            },
            {
              btnText: '確定',
              btnColor: 'primary',
              depressed: true,
              btnIsLoading: false,
              btnClick: async () => {
                this.$alert.close()
                this.discountCode.acceptResult = true
                resolve(true)
              }
            }
          ],
          persistent: true
        })
      })
    }
  }
}
